import {TextViewerContentDataVo} from '../../common/shared/api/gateway/viewer/TextViewerContentDataVo.interface';
import {TextViewerContentData} from '../generated/types';

export function createTextViewerContentData({
  chapter_id,
  content_id,
  secure_url,
}: TextViewerContentDataVo): TextViewerContentData {
  return {
    chapterId: chapter_id,
    contentId: content_id,
    secureUrl: secure_url,
  };
}
